var map = {
	"./cs/cookiespolicy.html": "7232",
	"./de/cookiespolicy.html": "74a5",
	"./en/cookiespolicy.html": "71af",
	"./es/cookiespolicy.html": "d503",
	"./fr/cookiespolicy.html": "e11d",
	"./it/cookiespolicy.html": "3151"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "927d";